import React, { useState, useEffect } from 'react';
import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExitToApp, Security } from '@material-ui/icons';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { useHistory } from 'react-router-dom';
import { USER } from '../../../constants/CommonConst';
import { decryptLocalStorage, handleLogout } from '../../../utils/authUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { ENVIRONMENT } from '../../../env/Configurations';

const useStyles = makeStyles((theme) => ({
  smallAvatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: 'pointer',
    backgroundColor: '#076c21',
  },
  largeAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: '#076c21',
  },
}));

const AuthHeader = ({ showProfile = false, mfaLogoutCallback }) => {
  const logo = '/assets/img/hudini-logo-black.png';
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const loggedinUser = decryptLocalStorage(USER);

  const handleUserMenuClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const userMenuOpen = Boolean(anchorEl);
  const id = userMenuOpen ? 'usermenu-popover' : undefined;

  const logout = async () => {
    try {
      handleUserMenuClose();
      
      // If we're in MFA flow, use the callback to reset to login form
      if (mfaLogoutCallback) {
        sessionStorage.clear();
        localStorage.clear();
        mfaLogoutCallback();
        notificationManager('success', 'Logged out successfully');
      } else {
        // Normal logout behavior for other auth pages
        sessionStorage.clear();
        handleLogout(history, true);
      }
    } catch (error) {
      notificationManager('danger', 'Unable to remove user lock');
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }
      handleUserMenuClose();
    }
  };

  const copyAPIKeyToClipboard = () => {
    const idTokenKey = Object.keys(localStorage)?.find((key) => key?.includes('idToken'));
    if (!idTokenKey) {
      notificationManager('danger', 'Invalid user session, API key not found');
      return;
    }

    const token = localStorage.getItem(idTokenKey);
    if (!token) {
      notificationManager('danger', 'Unable to locate API key');
      return;
    }

    navigator?.clipboard?.writeText(token).then(
      () => {
        notificationManager('success', 'API key successfully copied to clipboard');
      },
      (error) => {
        notificationManager('danger', 'Unable to copy API key to clipboard');
        if (ENVIRONMENT === 'dev') {
          console.log(error?.message);
        }
      },
    );
  };

  return (
    <div className='col w-100 mb-auto'>
      <div className='d-flex justify-content-between align-items-center px-4 py-3' style={{ minHeight: '60px' }}>
        <div className='logo d-flex align-items-center'>
          <img src={logo} className='header-logo' alt='logo' />
        </div>
        
        {/* Profile Popover - Only show when showProfile is true */}
        {showProfile && (
          <div className='nav-info-item d-flex align-items-center'>
            {loggedinUser?.imageUrl ? (
              <Avatar
                alt={loggedinUser?.firstName}
                src={loggedinUser?.imageUrl}
                className={`showpopup ${classes?.smallAvatar}`}
                onClick={handleUserMenuClick}
              />
            ) : (
              <Avatar onClick={handleUserMenuClick} className={`showpopup ${classes?.smallAvatar}`}>
                {loggedinUser?.firstName && loggedinUser?.firstName?.[0]}
              </Avatar>
            )}
            <Popover
              id={id}
              open={userMenuOpen}
              anchorEl={anchorEl}
              onClose={handleUserMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <div className='header-user-menu'>
                <div className='d-flex p-4'>
                  {loggedinUser?.imageUrl ? (
                    <Avatar
                      alt='User profile'
                      src={loggedinUser?.imageUrl}
                      className={classes?.largeAvatar}
                    />
                  ) : (
                    <Avatar className={classes?.largeAvatar}>
                      {loggedinUser?.firstName && loggedinUser?.firstName[0]}
                    </Avatar>
                  )}
                  <div className='ms-3 d-flex justify-content-center flex-column'>
                    <div className='header-user-menu-username'>
                      {loggedinUser?.firstName} {loggedinUser?.lastName}
                    </div>
                  </div>
                </div>
                <div className='header-user-menu-list'>
                  <Divider />
                  <List component='nav' aria-label='main user menu'>
                    <ListItem button onClick={(e) => copyAPIKeyToClipboard()}>
                      <ListItemIcon>
                        <ContentCopyRoundedIcon className='header-user-menu-icon-api-key-copy' />
                      </ListItemIcon>
                      <ListItemText primary='Copy API Key' />
                    </ListItem>
                    {/* <ListItem
                      button
                      onClick={() => {
                        handleUserMenuClose();
                        history.push('/mfa-setup');
                      }}
                    >
                      <ListItemIcon>
                        <Security color='primary' />
                      </ListItemIcon>
                      <ListItemText primary='MFA Setup' />
                    </ListItem> */}
                    <ListItem button onClick={(e) => logout()}>
                      <ListItemIcon>
                        <ExitToApp color='primary' />
                      </ListItemIcon>
                      <ListItemText primary='Logout' />
                    </ListItem>
                  </List>
                </div>
              </div>
            </Popover>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthHeader;
